/**
 * Global error tracking initialization.
 * This file is loaded on all pages via _Layout.cshtml.
 *
 * The DSN is injected from appsettings via window.__GLITCHTIP_DSN__.
 */
import { initErrorTracking, setUser } from '@/utils/errorTracking';

// Initialize error tracking with DSN from server
declare global {
  interface Window {
    __GLITCHTIP_DSN__?: string;
    __GLITCHTIP_ENV__?: string;
    __GLITCHTIP_TUNNEL__?: string;
    __USER_ID__?: string;
    __USER_EMAIL__?: string;
    __USER_TIER__?: string;
  }
}

if (window.__GLITCHTIP_DSN__) {
  initErrorTracking({
    dsn: window.__GLITCHTIP_DSN__,
    environment: window.__GLITCHTIP_ENV__ ?? 'production',
    tunnel: window.__GLITCHTIP_TUNNEL__,
    tracesSampleRate: 0.1,
  });

  // Set user context if available
  if (window.__USER_ID__) {
    setUser({
      id: window.__USER_ID__,
      email: window.__USER_EMAIL__,
      tier: window.__USER_TIER__,
    });
  }
}
